import React from "react";

import { IgLink, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

interface GoogleAnalyticsDisclaimerProps {
  marginLeft?: string;
}

export const GoogleAnalyticsDisclaimer = ({
  marginLeft,
}: GoogleAnalyticsDisclaimerProps) => {
  return (
    <Grid item sx={{ marginTop: "10px", marginLeft }}>
      <IgTypography variant={"body2"}>
        Intelligems' use or transfer of information from Google APIs will adhere
        to{" "}
        <IgLink
          onClick={() =>
            window.open(
              "https://developers.google.com/terms/api-services-user-data-policy",
              "_blank"
            )
          }
        >
          Google API Services User Data Policy
        </IgLink>
        , including the Limited Use requirements.
      </IgTypography>
    </Grid>
  );
};
